import { TimerObserver } from '../../libs/timerObserver';
import { timerKeys } from '../../shared/constants';
import { getLogger } from '../../libs/logger';

export enum CallDurationStep {
  Start = 'start',
  End = 'end',
}

class CallDurationTimerObserver extends TimerObserver<CallDurationStep> {
  constructor() {
    super(timerKeys.callDuration, getLogger('callDurationTimer'));
  }

  override start(): void {
    super.start(CallDurationStep.Start);
  }
}

export const callDurationTimer = new CallDurationTimerObserver();
